<template>
  <div>
    <div v-if="canShowContent">
      <Content
        model="page"
        :content="content"
        :api-key="apiKey"
        :data="{}"
        class="builder-io-hero-content"
      />
    </div>
  </div>
</template>
<script>
const apiKey = import.meta.env.VITE_APP_BUILDER_API_KEY;

import { Content, fetchOneEntry, isPreviewing } from "@builder.io/sdk-vue";

export default {
  name: "BuilderIoPageContent",
  components: {
    Content,
  },
  data: () => ({
    content: null,
    canShowContent: false,
    modelName: "page",
    apiKey,
    inprogress: false,
  }),
  methods: {
    async loadContent() {
      let vm = this;
      vm.inprogress = false;
      vm.content = await fetchOneEntry({
        model: "page",
        apiKey: vm.apiKey,
        userAttributes: {
          urlPath: "/homepage",
        },
      });
      vm.inprogress = true;
      vm.canShowContent = vm.content ? true : isPreviewing();
    },
  },
  async mounted() {
    this.loadContent();
  },
  created() {},
};
</script>
<style lang="scss"></style>
